import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const ModalSuccessWrapper = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'relative flex max-w-md flex-1 items-center overflow-hidden rounded-lg bg-white shadow-lg',
      className
    )}
    {...props}
  />
)
